import { comments } from '@/mocks/articles';

export default function TestimonialSection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col items-center text-center mb-14">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500" />
            <span className="text-xs text-foreground-500 font-medium tracking-wide uppercase">
              网友热评
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            吃瓜群众<br />都在说什么
          </h2>
          <p className="mt-3 text-foreground-500 text-sm max-w-md">
            来自全网各平台网友的真实评论与反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {comments.slice(0, 6).map((comment, index) => (
            <div
              key={comment.id}
              className={`bg-background-50 rounded-xl p-6 flex flex-col gap-4 transition-all duration-300 hover:-translate-y-1 ${
                index === 5 ? 'opacity-50' : ''
              }`}
            >
              <div className="flex items-center gap-1">
                {Array.from({ length: comment.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center" />
                ))}
              </div>
              <h4 className="text-sm font-semibold text-foreground-900 leading-relaxed">
                "{comment.content.slice(0, 40)}..."
              </h4>
              <p className="text-sm text-foreground-500 leading-relaxed flex-1">
                {comment.content}
              </p>
              <div className="flex items-center gap-3 pt-2 border-t border-background-200/70">
                <img
                  src={comment.userAvatar}
                  alt={comment.userName}
                  className="w-9 h-9 rounded-full object-cover"
                />
                <div className="flex flex-col">
                  <span className="text-sm font-semibold text-foreground-900">{comment.userName}</span>
                  <span className="text-xs text-foreground-400">{comment.platform} · {comment.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}